import { render, staticRenderFns } from "./ClearFilterButton.vue?vue&type=template&id=63318de3&"
import script from "./ClearFilterButton.vue?vue&type=script&lang=js&"
export * from "./ClearFilterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports